var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.583 5h3.25a.208.208 0 00.148-.356L13.689.354a.208.208 0 00-.356.146v3.25A1.25 1.25 0 0014.583 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 5.833h-3.542A2.083 2.083 0 0112.5 3.75V.207A.208.208 0 0012.292 0H3.333a1.667 1.667 0 00-1.666 1.667v16.666A1.667 1.667 0 003.333 20h13.334a1.667 1.667 0 001.666-1.667V6.04a.208.208 0 00-.208-.207zM7.547 15.16a.52.52 0 11-.93.466s-.719-1.424-.735-1.468a.055.055 0 00-.1 0l-.735 1.466a.52.52 0 01-.464.294.513.513 0 01-.232-.056.52.52 0 01-.234-.699l1.084-2.173a.21.21 0 000-.187l-1.084-2.177a.52.52 0 01.93-.466l.73 1.46a.06.06 0 00.11 0l.73-1.46a.52.52 0 11.93.466l-1.083 2.174a.21.21 0 000 .187zm3.703.758H9.583a1.356 1.356 0 01-1.354-1.354v-4.167a.52.52 0 111.042 0v4.167a.313.313 0 00.312.312h1.667a.52.52 0 010 1.042zm2.44-3.965l1.533 1.021a1.607 1.607 0 01-.89 2.944h-1.416a.52.52 0 010-1.042h1.416a.565.565 0 00.314-1.035l-1.534-1.022a1.606 1.606 0 01.892-2.943h1.417a.52.52 0 010 1.042H14a.565.565 0 00-.313 1.035z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.066bbf7e.svg";
export { ForwardRef as ReactComponent };